








import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';

export default Vue.extend({
  name: 'GSelectorForm',
  props: {
    isLabel: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    value: { type: Boolean as PropType<boolean> },
    label: { type: String as PropType<string>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
    isNotArrow: { type: Boolean as PropType<boolean>, default: false },
    name: { type: String as PropType<string>, required: true },
    reverse: { type: Boolean as PropType<boolean>, default: false },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue: {
      get(): boolean {
        return this.value;
      },
      set(val: boolean): void {
        this.$emit('input', val);
      },
    },
  },
  // methods: {
  //   onChange(e: Event): void {
  //     if (e.target instanceof HTMLInputElement) {
  //       this.$emit('change', e.target.value, e.target.checked);
  //     }
  //   },
  // },
});
